const routes = [
    {
        path: "/periods",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "period_index"
        }
    }
];

export default routes;
